import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Register } from 'src/app/Utils/service/Register.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { RequestRegister } from 'src/app/Models/input.model/RequestRegister';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  public registerForm: FormGroup;
  public m: RequestRegister;
  constructor(private renderer: Renderer2,
    private toastr: ToastrService,
    private RGT: Register,
    public spinner: NgxSpinnerService,
  ) { }

  ngOnInit() {
    this.renderer.addClass(document.body, 'register-page');
    this.m = new RequestRegister()
    this.registerForm = new FormGroup({
      UserName: new FormControl(null, Validators.required),
      Email: new FormControl(null, Validators.required)
    });
  }

  GetPassWord() {
    if (this.registerForm.valid) {
      this.m.UserName = this.registerForm.controls.UserName.value;
      this.m.Email = this.registerForm.controls.Email.value;
      if (this.ValidateEmail(this.m.Email)) {
        this.spinner.show();
        let req = {
          UserName: this.m.UserName,
          Email: this.m.Email,
          UserCategory: 1
        }
        this.RGT.GetPassWord(req)
          .subscribe({
            next: (z) => {
              this.spinner.hide();
              if (z.Status == 1) {
                this.toastr.success('Lấy lại mật khẩu thành công, kiểm tra email của bạn', 'Tác vụ thành công');
              } else {
                this.toastr.error(z.Message, 'Tác vụ thất bại');
              }
            },
            error: (err) => {
              this.spinner.hide();
              console.error('API Error:', err);
              this.toastr.error('Không thể kết nối đến hệ thống. Vui lòng thử lại sau.', 'Lỗi hệ thống');
            }
          });

      } else { this.toastr.warning('Địa chỉ email không đúng định dạng', 'Tác vụ thất bại'); }
    } else {
      this.toastr.error('Vui lòng nhập đầy đủ thông tin', 'Tác vụ thất bại');
    }
  }

  ValidateEmail(mail) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true
    }
    return false
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'register-page');
  }

}
